import { getInstance } from './auth0-plugin'

const maintenance = JSON.parse(process.env.VUE_APP_MAINTENANCE_STATUS)

export const authGuard = (to, from, next, guardOptions) => {
  const authService = getInstance()
  
  const { entities, adminEntities, writeActions } = guardOptions
  const adminScopes = authService.buildScopes(adminEntities)
  const writeScopes = authService.buildScopes(entities, writeActions)

  const guardAction = () => {
    if (authService.isAuthenticated) {
      const isAdminUser = authService.checkScopes(adminScopes)
      const hasWriteAccess = authService.checkScopes(writeScopes)
      if (authService.tenantTitle) {
        document.title = `${authService.tenantTitle} | ${to.meta.title}`
      }
      if (maintenance) {
        if (to.path !== '/') return next('/')
        else return next()
      }
      if (to.meta.adminOnly && !isAdminUser) {
        return next('/')
      }
      if (to.meta.requiresWriteAccess && !hasWriteAccess) {
        return next('/')
      }
      return next()
    }
    const redirectOptions = { appState: { targetUrl: to.fullPath } }
    authService.loginWithRedirect({ ...redirectOptions })
  }

  // If the Auth0Plugin has loaded already, check the authentication state
  if (!authService.isLoading) {
    return guardAction()
  }

  authService.$watch('isLoading', (isLoading) => {
    if (isLoading === false) {
      return guardAction()
    }
  })
}
